import { render } from "./ContadorHistorial.vue?vue&type=template&id=146d50b7&scoped=true"
import script from "./ContadorHistorial.vue?vue&type=script&lang=js"
export * from "./ContadorHistorial.vue?vue&type=script&lang=js"

import "./ContadorHistorial.vue?vue&type=style&index=0&id=146d50b7&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146d50b7"]])

export default __exports__